/** @typedef {{ idFila: string, id_area: number, correo: string }} CorreoPorAreaFila */

/**
 * @param {unknown} raw
 * @returns {CorreoPorAreaFila[]}
 */
export function normalizarCorreosPorArea(raw) {
    if (!Array.isArray(raw)) return [];
    const out = [];
    raw.forEach((item, idx) => {
        if (!item || typeof item !== "object") return;
        const o = /** @type {Record<string, unknown>} */ (item);
        if (typeof o.idFila === "string" && o.idFila.trim()) {
            const id_area = Number(o.id_area);
            const correo = String(o.correo ?? "").trim();
            if (Number.isFinite(id_area) && correo) {
                const nombre_area =
                    typeof o.nombre_area === "string" && o.nombre_area.trim()
                        ? o.nombre_area.trim()
                        : undefined;
                out.push({
                    idFila: o.idFila.trim(),
                    id_area,
                    correo,
                    ...(nombre_area ? { nombre_area } : {}),
                });
            }
            return;
        }
        const id_area = Number(o.id_area);
        const correo = String(o.correo ?? "").trim();
        if (!Number.isFinite(id_area) || !correo) return;
        const idFila =
            typeof o.idFila === "string" && o.idFila.trim()
                ? o.idFila.trim()
                : o.id != null
                  ? `db-${o.id}`
                  : `fila-${id_area}-${idx}-${correo}`;
        const nombre_area =
            typeof o.nombre_area === "string" && o.nombre_area.trim()
                ? o.nombre_area.trim()
                : undefined;
        out.push({ idFila, id_area, correo, ...(nombre_area ? { nombre_area } : {}) });
    });
    return out;
}

/**
 * @param {CorreoPorAreaFila[] | null | undefined} filas
 * @returns {{ id_area: number, correo: string }[]}
 */
export function serializeCorreosPorAreaParaApi(filas) {
    if (!Array.isArray(filas)) return [];
    return filas
        .map((f) => ({
            id_area: Number(f.id_area),
            correo: String(f.correo ?? "").trim(),
        }))
        .filter((r) => Number.isFinite(r.id_area) && r.id_area > 0 && r.correo.length > 0);
}
